import React, { useState } from "react";
import styles from "../settings.module.css";
import Select from "../../../../../components/CustomSelect/Select";
import TimezoneSelect from "../../../../../components/CustomSelect/TimezoneSelect";
import { useDispatch, useSelector } from "react-redux";
import { currencies } from "../../../../../config/data/currencies";
import { Form } from "react-bootstrap";
import { editGeneralSettings } from "../../../../../general_redux/general settings/actions";

function General() {
  const { setting, dateFormatArray } = useSelector(
    ({ generalSetting }) => generalSetting && generalSetting
  );

  const dispatch = useDispatch();
  const [defaultCurrency, setDefaultCurrency] = useState(
    setting.currency ? setting.currency : ""
  );
  const [timeFormat, setTimeFormat] = useState(
    setting.timeDisplay ? setting.timeDisplay : ""
  );
  const [dateFormat, setDateFormat] = useState(
    setting.dateDisplay ? setting.dateDisplay : ""
  );
  const [timezone, setTimezone] = useState(
    setting && setting.timezone
      ? setting.timezone
      : Intl.DateTimeFormat().resolvedOptions().timeZone
  );

  const handleSave = (e) => {
    e.preventDefault();
    const data = {
      generalSettings: {
        currency: defaultCurrency.value,
        timeDisplay: timeFormat,
        dateDisplay: dateFormat,
        timezone: timezone.value ? timezone.value : timezone,
      },
    };
    dispatch(editGeneralSettings(data));
  };

  return (
    <div mt-1>
      <div className="pb-2 d-flex flex-direction-column">
        <h2 className={styles.settings__header}>General Settings</h2>
      </div>
      <Form
        onSubmit={handleSave}
        className={styles.settings_wrapper}
        autoComplete="off"
      >
        <div className={`input-group mb-3 ${styles.input_group}`}>
          <div className="input-group-prepend">
            <label
              className={`input-group-text ${styles.input_group_text}`}
              htmlFor="propertyType"
            >
              Default currency:
            </label>
          </div>

          <Select
            options={currencies}
            value={defaultCurrency}
            onChange={(val) => setDefaultCurrency(val)}
            className={`custom-select ${styles.form_entry}`}
          />
        </div>

        <div className={`input-group mb-3 ${styles.input_group}`}>
          <div className="input-group-prepend">
            <label
              className={`input-group-text ${styles.input_group_text}`}
              htmlFor="timeFormat"
            >
              Time display:
            </label>
          </div>
          <select
            onChange={(e) => setTimeFormat(e.target.value)}
            className={`custom-select ${styles.form_control}`}
            id="timeFormat"
            value={timeFormat}
            style={{ fontSize: "inherit" }}
          >
            <option value="" disabled>
              --- Select time format ---
            </option>
            <option value="AM_PM">AM / PM</option>
            <option value="H">24 H</option>
          </select>
        </div>

        <div className={`input-group mb-3 ${styles.input_group}`}>
          <div className="input-group-prepend">
            <label
              className={`input-group-text ${styles.input_group_text}`}
              htmlFor="dateFormat"
            >
              Date display:
            </label>
          </div>
          <select
            onChange={(e) => setDateFormat(e.target.value)}
            className={`custom-select ${styles.form_control}`}
            id="dateFormat"
            value={dateFormat}
            style={{ fontSize: "inherit" }}
          >
            <option value="" disabled>
              --- Select date format ---
            </option>
            {dateFormatArray &&
              dateFormatArray.map((t) => (
                <option value={t.val} defaultValue={dateFormat} key={t.id}>
                  {t.display}
                </option>
              ))}
          </select>
        </div>

        <div className={`input-group mb-3 ${styles.input_group}`}>
          <div className="input-group-prepend">
            <label
              className={`input-group-text ${styles.input_group_text}`}
              htmlFor="timeZone"
            >
              Time zone:
            </label>
          </div>
          <div className={"w-100"}>
            <TimezoneSelect value={timezone} onChange={setTimezone} />
          </div>
        </div>
        <div className="d-flex justify-content-start">
          <button className={styles.settings_save} type="submit">
            Save Changes
          </button>
        </div>
      </Form>
    </div>
  );
}

export default General;
